import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import avatar from '../../assets/images/avatar';

class DropDown extends Component {
  static propTypes = {
    navBarTextClass: PropTypes.string,
    handleLogout: PropTypes.func,
    settingsPath: PropTypes.string
  }

  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.dropdownContainer = null;
  }

  toggleDropdown = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  componentDidMount() {
    document.body.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleOutsideClick);
  }

  setDropdownContainerRef = (ref) => {
    this.dropdownContainer = ref;
  };

  handleOutsideClick = (event) => {
    if (this.dropdownContainer && !this.dropdownContainer.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };
  
  render() {
    const { isOpen } = this.state;
    const { navBarText, handleLogout, settingsPath } = this.props;

    return (
      <div ref={this.setDropdownContainerRef}>
        <div className="header__dropdown" onClick={this.toggleDropdown}>
          <span>
            <img className='header__dropdown_image' src={ avatar } />
            </span>
          <span className={'header__dropdown_text'}>
            {navBarText}
          </span>
          <i aria-hidden='true' className={ `fa fa-angle-down header__dropdown_text` } />
          {isOpen && (
            <ul className='header__dropdown_list'>
              <li>
                <Link className='header__settings' key='settings' to={ settingsPath } onClick={this.toggleDropdown}>
                  Settings <i className='fa fa-cog'/>
                </Link>
              </li>
              <li>
                <a href='#' key='logout' onClick={ handleLogout }>Log Out</a>
              </li>
            </ul>
          )}
        </div>
      </div>
    );
  }
};

export default DropDown;



// WEBPACK FOOTER //
// ./app/components/layouts/_DropDown.jsx